import { render, staticRenderFns } from "./CheckoutCounter.vue?vue&type=template&id=6b6013dd"
import script from "./CheckoutCounter.vue?vue&type=script&lang=js"
export * from "./CheckoutCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports